module.exports = __webpack_public_path__ + "static/sarah_holzhauer-e2e2718d3ff8f7fb8dcf7ca493ad5168.jpg";